import { Box, Text } from '@vouched.id/vault';
import React from 'react';
import { Dropdown } from '../Dropdown';
import { AMLCaption } from './AMLCaption';
import { AmlV2CompletedResult } from 'components/account/jobs-v2/dropdowns/AML/AmlV2CompletedResult';
import { JobExecutionStatus } from 'models/jobs/shared';
export const AmlV2Dropdowns = ({ jobStatus, job }) => {
    if (job.initialScreening.status === JobExecutionStatus.Error) {
        return (React.createElement(Dropdown, { title: "AML" },
            React.createElement(Box, null,
                React.createElement(AMLCaption, null),
                React.createElement(Text, null, "AML could not be completed. Please try again or contact support."))));
    }
    return React.createElement(AmlV2CompletedResult, { job: job, jobStatus: jobStatus });
};
